import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import appleStoreImg from './../../../assets/app-store.png';
import googlePlayImg from './../../../assets/google-play.png';
import '../TaskDetail.css';

const Download: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="download-container">
      <div className="download-description">
        <p>{t('#Task.goodmates_description')}</p>
        <p>{t('#Task.download_and_join_campaign')}</p>
      </div>

      <div className="download-icons">
        <a
          href="https://apps.apple.com/hk/app/goodmates/id1559340728"
          className="download-icon-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={appleStoreImg}
            alt="goodmates-iOS"
            className="download-icon-img"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=org.goodmates"
          className="download-icon-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={googlePlayImg}
            alt="goodmates-Android"
            className="download-icon-img"
          />
        </a>
      </div>
    </div>
  );
}

export default Download;